export const getTextDirection = (element) => {
    return getComputedStyle(element).direction;
};
